/**
 * HelpPopup.js
 * Author: Markus.van.Kempen@gmail.com
 * Date: 2nd Nov 2025
 */

import React, { useState, useRef, useEffect } from 'react';
import './HelpPopup.css';

const HelpPopup = ({ title, children, position = 'right' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const popupRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isOpen]);

  return (
    <div className="help-popup-container" ref={popupRef}>
      <span
        role="button"
        tabIndex={0}
        className="help-icon-button"
        onClick={() => setIsOpen(!isOpen)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setIsOpen(!isOpen);
          }
        }}
        title="Click for help"
        aria-label="Click for help"
      >
        <span className="help-icon">❓</span>
      </span>
      
      {isOpen && (
        <div className={`help-popup-content ${position}`}>
          {title && <div className="help-popup-title">{title}</div>}
          <div className="help-popup-body">
            {children}
          </div>
          <button 
            className="help-popup-close"
            onClick={() => setIsOpen(false)}
          >
            Got it!
          </button>
        </div>
      )}
    </div>
  );
};

export default HelpPopup;

